import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-view-remarks',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './view-remarks.component.html',
  styleUrl: './view-remarks.component.scss'
})
export class ViewRemarksComponent implements OnInit {
  @Input() remarksInfo: any;
  @Input() isApprovalView: boolean = false;
  @Input() isQuotationView: boolean = false;
  @Input() isPolicyView : boolean = false;

  queryParams: any = {};
  isFromMotorApproval: boolean = false;

  constructor(
    public store: Store
  ) {}

  ngOnInit() {
    this.queryParams = this.store.selectSnapshot<any>((state) => state.UserState.queryParams);
    this.isFromMotorApproval = this.queryParams?.isFromMotorApproval;
  }  
}
